import { HTMLAudioElementWithSetSinkId } from '@/entities/media-devices'

import { tauriMode } from '@/shared/utils/import-meta'
import { isTypedKeyInObject } from '@/shared/utils/isTypedKeyInObject'
import { isLinuxOrUnixPlatform } from '@/shared/utils/tauri-platform'

import { CustomNavigator } from './use-app-badge'
import { checkBrowserType } from './use-check-browser-type'

/** Web Notifications API is missing in iOS Safari browser tabs (available in installed PWA). */
export const isWebNotificationApiAvailable = (): boolean => {
  return typeof window !== 'undefined' && 'Notification' in window
}

export const useBrowserSupport = () => {
  const canUseSetAudioOutput = async (mediaElement: HTMLAudioElementWithSetSinkId) => {
    if(tauriMode() && await isLinuxOrUnixPlatform()) {
      return true
    }
    return isTypedKeyInObject(mediaElement, 'setSinkId', 'function')
  }
  const canUseAppBadge = () => {
    return isTypedKeyInObject(navigator as CustomNavigator, 'setAppBadge', 'function')
  }

  const canUseClearAppBadge = () => {
    return isTypedKeyInObject(navigator as CustomNavigator, 'clearAppBadge', 'function')
  }
  const canUseSpeakersChange = () => {
    const { userBrowser } = checkBrowserType()
    return (userBrowser.value !== 'firefox' && userBrowser.value !== 'safari')
  }

  const canUseWindowLocationSearch = (): boolean => {
    return !!window.location.search && typeof window.location.search === 'string'
  }

  const canUseLaunchQueue = (): boolean => {
    return 'launchQueue' in window
  }

  const canUseWebNotifications = (): boolean => isWebNotificationApiAvailable()

  return {
    canUseAppBadge,
    canUseClearAppBadge,
    canUseLaunchQueue,
    canUseWebNotifications,
    canUseSetAudioOutput,
    canUseSpeakersChange,
    canUseWindowLocationSearch,
  }
}
